
export default function Pricing() {
  const pricingPlans = [
    {
      title: '水回り3点お選びセット',
      price: '27,500円/1セット',
      description: '気になる箇所3点、お好きな組み合わせで選んで頂けます。'
    },
    {
      title: '水回り5点セット',
      price: '38,500円/1セット',
      description: 'キッチン・換気扇・お風呂・トイレ・洗面所'
    }
  ];

  return (
    <section id="pricing" className="py-12 sm:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-8">
          {pricingPlans.map((plan, index) => (
            <div key={index} className="bg-[#F5F3EF] rounded-lg p-5 sm:p-8">
              <h3 className="text-lg sm:text-2xl font-bold mb-3 sm:mb-4 text-gray-800">{plan.title}</h3>
              <p className="text-2xl sm:text-3xl font-bold mb-3 sm:mb-4 text-gray-800">{plan.price}</p>
              <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{plan.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
